var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.entitiesSlice,"headers":_vm.headers,"show-select":"","server-items-length":_vm.pageParams.total,"options":_vm.moduleOptions,"loading-text":"Загрузка... Пожалуйста подождите","footer-props":{
      'show-first-last-page': true,
      'items-per-page-options': [5, 10, 15, 30,50],
    }},on:{"update:options":function($event){_vm.moduleOptions=$event},"click:row":function (ref) {
            var id = ref.id;

            return _vm.$router.push({ name: 'RepresentativeDetail', params: { id: id } });
}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('UIActions',{attrs:{"selected":_vm.selected},on:{"create":function($event){return _vm.$router.push({ name: 'RepresentativeCreate' })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }